import type { StatusOption } from "../hooks/useStatusOptions.ts"
import type { FileItem } from "../types/file-item.types.ts"

// The Status picker offers only what `change-status` will actually accept
// from here (`file.nextStatuses`, itself the same transition graph the
// backend enforces) — never every status in the system. The current value
// stays in the list too, purely so antd's `Select` can still resolve its
// own label in the closed state; re-picking it is a harmless no-op antd
// does not even fire `onChange` for.
export const availableStatusOptions = (
  options: StatusOption[],
  file: Pick<FileItem, "status" | "nextStatuses">
): StatusOption[] =>
  options.filter(
    (option) =>
      option.value === file.status ||
      (file.nextStatuses ?? []).includes(option.value)
  )
